<template>
<main class="content">
  <div class="container">
    <h3>Наш блог</h3>
    <div class="row">
      <BlogItem
          v-for="item in articlesList"
          v-bind:item = "item"
      />
    </div>
  </div>
</main>
</template>

<script>
import BlogItem from "@/components/BlogItem";
import {mapGetters} from "vuex";
export default {
  name: 'Blog',
  components: {BlogItem},
  methods: {},
  computed: {
    ...mapGetters([
        'articlesList'
    ])
  },
  mounted() {
  }
}
</script>

<style scoped lang='scss'>
.content {
  background-color: #eee;
}
.container {
  @media (max-width: 997.98px) {
    overflow-x: hidden;
  }
}
h3 {
  font-weight: 500;
  font-size: 4rem;
  margin-bottom: 20px;
  padding-top: 45px;
}
.row {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -40px;
  justify-content: space-between;
}
</style>
